"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ListMaxIndentLevelPlugin;
var _list = require("@lexical/list");
var _LexicalComposerContext = require("@lexical/react/LexicalComposerContext");
var _lexical = require("lexical");
var _react = require("react");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function getElementNodesInSelection(selection) {
  var nodesInSelection = selection.getNodes();
  if (nodesInSelection.length === 0) {
    return new Set([selection.anchor.getNode().getParentOrThrow(), selection.focus.getNode().getParentOrThrow()]);
  }
  return new Set(nodesInSelection.map(function (n) {
    return (0, _lexical.$isElementNode)(n) ? n : n.getParentOrThrow();
  }));
}
function isIndentPermitted(maxDepth) {
  var selection = (0, _lexical.$getSelection)();
  if (!(0, _lexical.$isRangeSelection)(selection)) {
    return false;
  }
  var elementNodesInSelection = getElementNodesInSelection(selection);
  var totalDepth = 0;
  var _iterator = _createForOfIteratorHelper(elementNodesInSelection),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var elementNode = _step.value;
      if ((0, _list.$isListNode)(elementNode)) {
        totalDepth = Math.max((0, _list.$getListDepth)(elementNode) + 1, totalDepth);
      } else if ((0, _list.$isListItemNode)(elementNode)) {
        var parent = elementNode.getParent();
        if (!(0, _list.$isListNode)(parent)) {
          throw new Error("ListMaxIndentLevelPlugin: A ListItemNode must have a ListNode for a parent.");
        }
        totalDepth = Math.max((0, _list.$getListDepth)(parent) + 1, totalDepth);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return totalDepth <= maxDepth;
}
function ListMaxIndentLevelPlugin(_ref) {
  var maxDepth = _ref.maxDepth;
  var _useLexicalComposerCo = (0, _LexicalComposerContext.useLexicalComposerContext)(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  (0, _react.useEffect)(function () {
    return editor.registerCommand(_lexical.INDENT_CONTENT_COMMAND, function () {
      return !isIndentPermitted(maxDepth !== null && maxDepth !== void 0 ? maxDepth : 7);
    }, _lexical.COMMAND_PRIORITY_HIGH);
  }, [editor, maxDepth]);
  return null;
}